import {
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  Grid,
  IconButton,
  Typography,
} from "@material-ui/core";
import { AddCircle } from "@material-ui/icons";
import { FieldArray } from "formik";
import React, { useEffect, useState } from "react";
import InputField from "src/components/ui-components/InputField";
import DeleteIcon from "@material-ui/icons/Delete";
import SelectField from "src/components/ui-components/SelectField";

function ApiAuth({
  value,
  parameterList,
  contentTypeMaster,
  requestBodyDataTypeMaster,
  webMethodVerbMaster,
  fieldDataTypeMaster,
  fieldDataTypeFormatMaster,
  fieldArrayRef
}) {
  const [isContentTypeRaw, setIsContentTypeRaw] = useState(false);
  const [selectedContentType, setSelectedContentType] = useState("");

  useEffect(() => {
    if (parameterList?.current?.values?.isEdit) {
      const contentType = contentTypeMaster?.find(
        (x) =>
          x.contentTypeKey === parameterList?.current?.values?.oAuthContentType
      )?.contentType;
      setSelectedContentType(contentType);
      setIsContentTypeRaw(contentType === "raw");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    parameterList?.current?.values?.oAuthContentType,
    contentTypeMaster,
    requestBodyDataTypeMaster,
  ]);

  const handleContentTypeChange = (newValue) => {
    parameterList.current.setFieldValue(
      "oAuthContentType",
      newValue?.contentTypeKey
    );
    setSelectedContentType(newValue?.contentType);
    const contentType = contentTypeMaster.find(
      (x) => x.contentTypeKey === newValue?.contentTypeKey
    )?.contentType;
    if (contentType === "raw") {
      setIsContentTypeRaw(true);
      parameterList.current.setFieldValue("webMethodsOAuth2RequestParams", [
        {
          paramsKey: null,
          paramsValue: null,
        },
      ]);
    } else {
      setIsContentTypeRaw(false);
      parameterList.current.setFieldValue("oAuthRequestBodyDataType", "");
      parameterList.current.setFieldValue("oAuthRequestBody", "");
      parameterList.current.setFieldValue("webMethodsOAuth2RequestParams", [
        {
          paramsKey: null,
          paramsValue: null,
        },
      ]);
    }
  };

  return (
    <>
      {value === 2 && (
        <Grid spacing={2} container sx={{ paddingTop: "20px" }}>
          <Grid item xs={12}>
            <Typography variant="h6" gutterBottom>
              Request Parameters
            </Typography>
          </Grid>
          <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
            <SelectField
              label="Auth Verb *"
              name="oAuthWebmethodVerbKey"
              data={webMethodVerbMaster}
              dataTextField="webMethodVerb"
              dataValueField="webMethodVerbKey"
            />
          </Grid>
          <Grid item xs={12} sm={10} md={10} lg={10} xl={10}>
            <InputField label="Auth URL *" name="authURL" />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <SelectField
              label="Content Type *"
              name="oAuthContentType"
              data={contentTypeMaster}
              dataTextField="contentType"
              dataValueField="contentTypeKey"
              onChange={handleContentTypeChange}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <SelectField
              label={`Request Body Data Type${isContentTypeRaw ? " *" : ""}`}
              name="oAuthRequestBodyDataType"
              data={requestBodyDataTypeMaster}
              dataTextField="requestBodyDataType"
              dataValueField="requestBodyTypeKey"
              disable={!isContentTypeRaw}
            />
          </Grid>
          {selectedContentType &&
            selectedContentType !== null &&
            selectedContentType !== "" &&
            selectedContentType !== "raw" &&
            selectedContentType !== "none" && (
              <FieldArray name="webMethodsOAuth2RequestParams">
                {({ insert, remove, push }) => (
                  <>
                    {parameterList.current.values.webMethodsOAuth2RequestParams?.map(
                      (field, index) => (
                        <React.Fragment key={index}>
                          <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                            <InputField
                              label="Params Key *"
                              name={`webMethodsOAuth2RequestParams.${index}.paramsKey`}
                            />
                          </Grid>
                          <Grid item xs={12} sm={4} md={4} lg={4} xl={4}>
                            <InputField
                              label="Params Value *"
                              name={`webMethodsOAuth2RequestParams.${index}.paramsValue`}
                            />
                          </Grid>
                          <Grid item xs={2} sm={2} md={2} lg={2} xl={2} sx={{ display: "flex", alignItems: "center" }}>
                            {parameterList.current.values
                              .webMethodsOAuth2RequestParams.length > 1 && (
                                <IconButton
                                  sx={{ p: "10px" }}
                                  onClick={() => remove(index)}
                                >
                                  <DeleteIcon fontSize="medium" />
                                </IconButton>
                              )}
                            {index ===
                              parameterList.current.values
                                .webMethodsOAuth2RequestParams.length -
                              1 && (
                                <Button
                                  sx={{
                                    background:
                                      "linear-gradient(to bottom, #072f40, #072f40)",
                                    minWidth: 100,
                                  }}
                                  type="button"
                                  variant="contained"
                                  startIcon={<AddCircle />}
                                  onClick={() => {
                                    push({ paramsKey: "", paramsValue: "" });
                                  }}
                                  disabled={
                                    !field.paramsKey && !field.paramsValue
                                  }
                                >
                                  Add
                                </Button>
                              )}
                          </Grid>
                        </React.Fragment>
                      )
                    )}
                  </>
                )}
              </FieldArray>
            )}
          {selectedContentType === "raw" && (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <InputField
                label="Request Body *"
                name="oAuthRequestBody"
                multiline
                rows={6}
              />
            </Grid>
          )}
          <Grid item xs={12}>
            <Divider variant="fullWidth" />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <Grid direction="column" container spacing={2}>
              <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                <InputField label="Header Key *" name="headerKey" />
              </Grid>
              <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                <InputField label="Auth Token Field *" name="authTokenField" />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <InputField
              label="Headers"
              name="oAuthHeaders"
              multiline
              rows={4}
            />
          </Grid>
          {parameterList.current.values.oAuth2ResponseFields?.length > 0 && (
            <>
              <Grid item xs={12} key={parameterList.current.values.oAuth2ResponseFields.length}>
                <Divider variant="fullWidth" sx={{ paddingTop: "15px" }} />
              </Grid>
              <Grid item xs={12} sx={{ mb: 2 }} key={parameterList.current.values.oAuth2ResponseFields.length + 1}>
                <Typography variant="h6" gutterBottom>
                  Response Fields
                </Typography>
              </Grid>
            </>
          )}
          <FieldArray name="oAuth2ResponseFields">
            {() => (
              <>
                <Grid container ref={fieldArrayRef} spacing={2}>
                  {parameterList.current.values.oAuth2ResponseFields?.map(
                    (field, index) => (
                      <React.Fragment key={index}>
                        <Grid item xs={12} sm={2} md={1} lg={1} xl={1}>
                          <FormControlLabel
                            sx={{ mx: 3 }}
                            control={
                              <Checkbox
                                name={`oAuth2ResponseFields[${index}].save`}
                                checked={
                                  parameterList?.current?.values
                                    ?.oAuth2ResponseFields[index].save
                                }
                                onChange={parameterList?.current?.handleChange}
                              />
                            }
                            label={""}
                          />
                        </Grid>
                        <Grid item xs={12} sm={2} md={2} lg={2} xl={2}>
                          <InputField
                            label="Field Name *"
                            name={`oAuth2ResponseFields.${index}.fieldName`}
                          />
                        </Grid>
                        <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
                          <InputField
                            label="Display Name"
                            name={`oAuth2ResponseFields.${index}.displayName`}
                          />
                        </Grid>
                        <Grid item xs={12} sm={2} md={3} lg={3} xl={3}>
                          <SelectField
                            label="Field Type *"
                            name={`oAuth2ResponseFields.${index}.fieldType`}
                            data={fieldDataTypeMaster}
                            dataTextField="fieldType"
                            dataValueField="fieldDataTypeMasterKey"
                          />
                        </Grid>
                        <Grid item xs={12} sm={4} md={3} lg={3} xl={3}>
                          <SelectField
                            label="Format"
                            name={`oAuth2ResponseFields.${index}.format`}
                            data={fieldDataTypeFormatMaster}
                            dataTextField="format"
                            dataValueField="formatMasterKey"
                          />
                        </Grid>
                      </React.Fragment>
                    )
                  )}
                </Grid>
              </>
            )}
          </FieldArray>
        </Grid>
      )}
    </>
  );
}

export default ApiAuth;
